import React from 'react'
import { Pagination } from '../../interfaces/pagination'
import { LoadingRows } from '../LoadingRows/LoadingRows'

interface IProps extends Partial<Pagination> {}
export const LoadingListPage = (props: IProps) => (
  <div className="container-fluid">
    <div className="row justify-content-center">
      <div className="col-12 col-lg-10">
        <div className="header mt-md-5">
          <div className="header-body">
            <div className="row align-items-center">
              <div className="col">
                <h6 className="w-25 animate">&nbsp;</h6>
                <h1 className="w-50 animate">&nbsp;</h1>
              </div>
            </div>
          </div>
        </div>
        <div className="my-5">
          <LoadingRows {...props} />
        </div>
      </div>
    </div>
  </div>
)
